import type { Answers, ShadowGroup } from "../../../../types";

type DeriveShadowChildrenAnswersArgs = {
  shadowGroup: ShadowGroup;
  selectedValues: string[];
  answers: Answers;
};

/**
 * Pure helper: derive child question answers from a shadow group's current selection
 */
export const deriveShadowChildrenAnswers = ({
  shadowGroup,
  selectedValues,
  answers,
}: DeriveShadowChildrenAnswersArgs): Answers => {
  const selected = new Set<string>(selectedValues);
  const updated: Answers = { ...answers };
  for (const child of shadowGroup.names) {
    updated[child] = selected.has(child) ? "yes" : "no";
  }
  return updated;
};
